export const colStyles = {
  boxSizing: 'border-box' as const,
  flex: '0 0 auto',
  paddingLeft: '.5rem',
  paddingRight: '.5rem',
};
